import { ResponsivePicture } from "@/components/landing/ResponsivePicture";
import type { BlogPost } from "@/lib/blog";
import { readingMinutes } from "@/lib/blog";

export function PostCard({ post, eager = false }: { post: BlogPost; eager?: boolean }) {
  return (
    <article className="group relative flex h-full flex-col overflow-hidden border border-border bg-card shadow-[var(--shadow-stamp)] transition-transform duration-500 hover:-translate-y-1">
      <a href={`/blog/${post.slug}`} className="absolute inset-0 z-10" aria-label={post.title} />
      <div className="relative overflow-hidden">
        <ResponsivePicture
          {...post.cardPicture}
          alt={post.imageAlt}
          loading={eager ? "eager" : "lazy"}
          decoding="async"
          fetchPriority={eager ? "high" : "low"}
          className="aspect-[16/9] w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105"
        />
        <div className="pointer-events-none absolute inset-0 border-[6px] border-dashed border-parchment/60 mix-blend-overlay" />
      </div>
      <div className="flex flex-1 flex-col p-6">
        <div className="flex items-center justify-between gap-3">
          <span className="text-[10px] uppercase tracking-[0.24em] text-accent">{post.tag}</span>
          <span className="text-[10px] uppercase tracking-widest text-muted-foreground">
            {readingMinutes(post)} min read
          </span>
        </div>
        <h2 className="mt-2 font-display text-2xl text-primary group-hover:text-accent">
          {post.title}
        </h2>
        <p className="mt-1 text-xs text-muted-foreground">{post.dateLabel}</p>
        <p className="mt-3 flex-1 text-sm text-muted-foreground">{post.excerpt}</p>
        <span className="mt-5 text-sm font-medium text-accent">Read the article</span>
      </div>
    </article>
  );
}
